import React from "react";
import RangeDatePicker from "../../components/Comman/RangeDatePicker/RangeDatePicker";
import Button from "../../components/Button/Button";
import CategoryStatistics from "../../utils/Carousel";
import GradientLineChart from "../Graphs/GradientLineChart";
import GradientBarChart from "../Graphs/GradientBarChart";
import { generateHSLGradient } from "../../utils/Colors/Colors";
import HorizontalBarChart from "../Graphs/HorizontalBarChart";

export {};

const Reports = () => {
  // Define carousel slide styles
  const slideStyle: React.CSSProperties = {
    height: "400px", // Adjust this height as needed
    width: "100%",
  };

  const sampleData = [
    { name: "LASH", value: 28, ...generateHSLGradient(0) },
    { name: "TQSH", value: 48, ...generateHSLGradient(1) },
    { name: "HSEQ", value: 35, ...generateHSLGradient(2) },
    { name: "OPS", value: 42, ...generateHSLGradient(3) },
  ];
  const sampleData1 = {
    D1: 0,
    D2: 0,
    D3: 0,
    D4: 0,
    D5: 0,
    D6: 0,
    D7: 0,
  };

  return (
    <div>
      {/* <Header /> */}
      <h1 className="text-3xl font-bold">Reports</h1>
      <div>
        <div className="flex justify-between  bg-primary p-[15px] rounded-[10px] items-center">
          <div className="flex gap-[10px] items-center">
            <p className="info-col">Select Date Range:</p>
            <RangeDatePicker />
            <RangeDatePicker />
          </div>

          <div>
            <Button
              buttonText="Generate"
              padding="py-[16px] px-[36px]"
              text="text-[12px] 2xl:text-sm"
            />
          </div>
        </div>

        <div className="flex flex-wrap gap-[22px] mt-[20px]">
          <div className="w-full lg:w-[calc(75%-11px)] ">
            <CategoryStatistics />

            <div
              style={slideStyle}
              className="graph-dashboard bg-[#10151A] rounded-[15px] mt-[20px] p-[30px] "
            >
              <GradientLineChart
                data={[
                  { name: "Type A", value: 35, color: "#FF6B6B" },
                  { name: "Type B", value: 52, color: "#4ECDC4" },
                  { name: "Type C", value: 42, color: "#4ECDC4" },
                  { name: "Type D", value: 62, color: "#4ECDC4" },
                  { name: "Type E", value: 102, color: "#4ECDC4" },
                ]}
                title="PLS (P&L)"
              />
            </div>

            {/* <div style={slideStyle} className="graph-dashboard bg-[#10151A] rounded-[15px] mt-[20px] p-[30px]">
                <GradientBarChart data={sampleData} title="Del (Delivery)" />
              </div>
           */}
          </div>

          <div className=" w-full lg:w-[calc(25%-11px)]  ">
            <div className="flex lg:flex-col gap-[20px]">
              <div className="sm:w-[calc(50%-11px)] lg:w-full w-full ">
                <GradientBarChart data={sampleData} title="Del (Delivery)" />
              </div>

              <div className="sm:w-[calc(50%-11px)] lg:w-full w-full ">
                <HorizontalBarChart graphData={sampleData1} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reports;
